import * as React from 'react'
import { styled } from '@mui/material/styles'
import _ from 'lodash'

import { CardActionArea, AvatarGroup, Avatar, Tooltip } from '@mui/material'
import Stack from '@mui/material/Stack'

import { I18n, useTranslation } from 'components/hooks/use-translation'
import Text from 'components/atomic/atoms/text'
import Card from 'components/atomic/atoms/card'
import Chip from 'components/atomic/atoms/chip'

import * as PathsUtils from 'utils/paths'
import { PathGoal } from 'types/types'

const CardContent = styled('div')`
    min-height: 7rem;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    gap: 1rem;
    z-index: 1;
    top: 0;
    left: 0;
    &:hover {
        cursor: pointer;
    }
`

interface PreEnrolledCardProps {
    _id: string
    type: PathGoal
    to: string
    title: string
    short_description: string
    enrolled_users: number
}

const PreEnrolledCard = React.memo((props: PreEnrolledCardProps) => {
    const { t }: I18n = useTranslation()

    const colors = React.useMemo(() => PathsUtils.colorsFromItemType(props.type), [props.type])

    return (
        <CardActionArea sx={{ height: '100%' }}>
            <Card to={props.to}>
                <CardContent>
                    <Stack direction="row" justifyContent="space-between" alignItems="baseline" spacing={2}>
                        <Tooltip title={props.title} arrow disableHoverListener={props.title.length <= 50}>
                            <Text variant="h6">{_.truncate(props.title, { length: 50 })}</Text>
                        </Tooltip>

                        <Chip
                            size="small"
                            variant="outlined"
                            label={t(`common:pathGoal.${props.type}`)}
                            sx={{ borderColor: colors[0], backgroundColor: colors[1] }}
                        />
                    </Stack>

                    <Text variant="caption" color="text.secondary">
                        {props.short_description}
                    </Text>

                    <Stack direction="row" alignItems="center" spacing="0.2rem">
                        <AvatarGroup spacing="medium">
                            {Array.from(Array(3)).map((_, i) => (
                                <Avatar
                                    key={i}
                                    alt=""
                                    sx={{ width: 20, height: 20 }}
                                    src={`https://i.pravatar.cc/20?u=${props._id}${i}`}
                                />
                            ))}
                        </AvatarGroup>
                        <Text variant="caption" color="text.secondary">
                            {t(`paths:otherStudentsPreEnrolled`, { count: props.enrolled_users })}
                        </Text>
                    </Stack>
                </CardContent>
            </Card>
        </CardActionArea>
    )
})

export default PreEnrolledCard
